import {
  HttpClient,
  HttpErrorResponse,
  HttpInterceptorFn,
} from '@angular/common/http';
import { HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { inject } from '@angular/core';
import { error } from 'console';
import {
  BehaviorSubject,
  catchError,
  filter,
  Observable,
  switchMap,
  take,
  throwError,
} from 'rxjs';
import { environment } from './Environment/environment';
import { apiEndPoints } from './api/apiEndPoint';

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  let token: string | null = null;
  const http = inject(HttpClient);
  let isRefreshing = false;
  const refreshTokenSubject: BehaviorSubject<string | null> =
    new BehaviorSubject<string | null>(null);

  token = localStorage.getItem('jwtToken');

  const authReq = token
    ? req.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      })
    : req;

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (
        error.status === 401 &&
        !authReq.url.includes('Account/GenerateJwtToken')
      ) {
        return handle401(authReq, next, http);
      }
      return throwError(() => error);
    })
  );

  function handle401(
    req: HttpRequest<unknown>,
    next: HttpHandlerFn,
    http: HttpClient
  ): Observable<HttpEvent<unknown>> {
    const refreshToken = localStorage.getItem('refreshToken');

    if (!refreshToken) {
      return throwError(() => new Error('Refresh token not found'));
    }

    if (!isRefreshing) {
      isRefreshing = true;
      refreshTokenSubject.next(null);

      return http
        .post<any>(`${environment.baseUrl}${apiEndPoints.refreshToken}`, {
          refreshToken,
        })
        .pipe(
          switchMap((res) => {
            const newToken = res.body?.details?.jwtToken;
            if (newToken) {
              localStorage.setItem('jwtToken', newToken);
              refreshTokenSubject.next(newToken);
              isRefreshing = false;

              const clonedReq = req.clone({
                setHeaders: { Authorization: `Bearer ${newToken}` },
              });
              return next(clonedReq);
            } else {
              isRefreshing = false;
              return throwError(() => new Error('Failed to refresh token'));
            }
          }),
          catchError((err) => {
            isRefreshing = false;
            return throwError(() => err);
          })
        );
    } else {
      return refreshTokenSubject.pipe(
        filter((token) => token !== null),
        take(1),
        switchMap((token) => {
          const clonedReq = req.clone({
            setHeaders: { Authorization: `Bearer ${token}` },
          });
          return next(clonedReq);
        })
      );
    }
  }
};
